export * from './story-image.module';
